<template>
    <v-card v-if="menuRapido" dark class="menu-acesso-rapido" height="0px">
        <v-bottom-nav dark>
            <v-btn to="/" dark>
                <span>Inicio</span>
                <v-icon>home</v-icon>
            </v-btn>

            <v-btn to="/comunicados-listagem" dark>
                <span>Comunicados</span>
                <v-icon>announcement</v-icon>
            </v-btn>

            <v-btn to="/eventos-listagem" dark>
                <span>Eventos</span>
                <v-icon>event</v-icon>
            </v-btn>

            <v-btn @click="goToProfile" dark>
                <span>Meu perfil</span>
                <v-icon>face</v-icon>
            </v-btn>
        </v-bottom-nav>
    </v-card>
    
    
</template>


<script>
import firebase,{ storage } from 'firebase';
import { userProperties, pushProperties } from '@/global.js'

export default {
    name: 'AppFastNavigation',
    data() {
        return {
            menuRapido: false
        };
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        }
    },
    watch:{
        // verifica se a roda é diferente de /sign-in para exibir o menu rapido inferior
        $route (to, from){
            if(to.path == "/sign-in")
                this.menuRapido = false
            else
                this.menuRapido = true
        }
    },
    methods: {
        goToProfile(){
            this.$router.push(`/Perfil/?slug=`+userProperties.slug)
        }
    },
    created(){
        this.menuRapido = userProperties.loaded;
    }
};

</script>

<style scoped>
a {
    color: white;
    text-decoration: none;
}

.logout{
    position: relative;
    right: -4px;
}

.div-logout{
    margin-top: 15px
}

.profile{
    text-align: center;
}

.profile img{
    width: 30%;
    height: auto;
    margin: 20px auto 10px auto;
}

.v-alert.warning--text{
    background: #fff;
    margin: 10px;
}

a.fecharAviso{
    color: red;
    position: absolute;
    right: 0;
    top: -27px;
    color: #fff;
}

</style>
